// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1VrDy","inputWrap":"CustomTip_inputWrap__3W1eP"};